import "./counter_regulars"
import "./idles"
import "./ngs"
import "./troubles"

document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#wi-ccp-ps", function(){
    const width = screen.availWidth / 2;
    const height = screen.availHeight / 2;
    const left = (screen.availWidth - width) / 2;
    const top = (screen.availHeight - height) / 2;

    window.open(
      "/dashboard/index/wi_ccp_ps", 
      "_blank", 
      `width=${width},height=${height},top=${top},left=${left}`
    );
  })
})